import React from 'react'
import PropTypes from '../../utils/propTypes'

import classNames from 'classnames'

import { Card, CardBody, CardTitle, CardSubtitle, CardText } from 'reactstrap'
import Typography from '../Typography'

const TextWidget = ({ bgColor, title, subtitle, text, className, span, ...restProps }) => {
  const classes = classNames('cr-widget', className, {
    [`bg-${bgColor}`]: bgColor,
  })
  return (
    <Card body {...restProps} style={{ minHeight: '100%' }}>
      <div className="d-flex justify-content-between">
        <CardText tag="div">
          <small>{span}</small>
          <Typography className="mb-0">
            <strong>{title}</strong>
          </Typography>
        </CardText>
        <CardTitle>
          <strong>{text}</strong>
        </CardTitle>
      </div>
    </Card>
  )
}

TextWidget.propTypes = {
  bgColor: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

TextWidget.defaultProps = {
  bgColor: 'white',
}

export default TextWidget
